import { Injector, ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { Config, ConfigInitializerService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { MainStatePersistenceService } from './main-phone-state-persistence.service';
import { MainPhoneStoreModule } from './store/main-phone-store.module';

function statePersistenceFactory(injector: Injector): () => Observable<Config> {
  return () => {
    const mainStatePersistenceService = injector.get(MainStatePersistenceService);
    const configInit = injector.get(ConfigInitializerService);

    return configInit.getStable('context').pipe(
      tap(() => {
        mainStatePersistenceService.sync();
      }),
    );
  };
}

@NgModule({
  imports: [MainPhoneStoreModule],
})
export class MainPhoneDataAccessModule {
  static forRoot(): ModuleWithProviders<MainPhoneDataAccessModule> {
    return {
      ngModule: MainPhoneDataAccessModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = statePersistenceFactory(inject(Injector));

          return initializerFn();
        }),
      ],
    };
  }
}
